import axiosInstance from "../../lib/axiosInstance";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  setLoadingSequences,
  setSequences,
  setErrorLoadingSequences,
} from "../slices/sequence";

export const getSequences = () => async (dispatch) => {
  dispatch(setLoadingSequences());
  try {
    const { data } = await axiosInstance.get("/sequences", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setSequences(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingSequences(getErrorMessage(error)));
  }
};
